const languages = [{ key: 'en' }, { key: 'fr' }, { key: 'es' }];
export default languages;
